module.exports = __webpack_public_path__ + "static/img/1_12.3d70a01a.jpg";